import React from 'react';
import './FoldLoaderLines.css';
import { foldLoaderVariantsEnum } from '../../../../../shared/src/enums/promotions.enum';

export const FoldLoaderLines = ({
    className = '',
    linesVariationName = null,
}) => {
    const lineVariationComponentsMap = {
        [foldLoaderVariantsEnum.DOTTED_SIMPLE]: (
            <>
                <span className="asg-promotion-fold__loader-line-dotted">
                    <span className="asg-promotion-fold__loader-line asg-promotion-fold__loader-line--length-76" />
                    <span className="asg-promotion-fold__loader-line asg-promotion-fold__loader-line--length-16" />
                </span>
                <span className="asg-promotion-fold__loader-line asg-promotion-fold__loader-line--length-49" />
            </>
        ),
        [foldLoaderVariantsEnum.DOTTED_2ND_LINE_SPLIT]: (
            <>
                <span className="asg-promotion-fold__loader-line-dotted">
                    <span className="asg-promotion-fold__loader-line asg-promotion-fold__loader-line--length-76" />
                    <span className="asg-promotion-fold__loader-line asg-promotion-fold__loader-line--length-16" />
                </span>
                <span
                    className="asg-promotion-fold__loader-line-dotted asg-promotion-fold__loader-line-dotted--centered"
                >
                    <span className="asg-promotion-fold__loader-line asg-promotion-fold__loader-line--length-52" />
                    <span className="asg-promotion-fold__loader-line asg-promotion-fold__loader-line--length-40" />
                </span>
            </>
        ),
    };

    // default variation - 3 lines
    const defaultLinesVariation = (
        <>
            <span className="asg-promotion-fold__loader-line" />
            <span className="asg-promotion-fold__loader-line asg-promotion-fold__loader-line--length-80" />
            <span className="asg-promotion-fold__loader-line asg-promotion-fold__loader-line--length-70" />
        </>
    );

    const linesVariation = lineVariationComponentsMap[linesVariationName] ?? defaultLinesVariation;

    return (
        <div className={`asg-promotion-fold__loader-lines ${className}`}>
            {linesVariation}
        </div>
    );
};
